import styled from 'styled-components';

const PageTitle = styled.h2`
  font-size: 18px;
  line-height: 34px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.heading_dark};
  margin-bottom: 16px;
`;

const PageLinks = styled.a`
  color: #3b82f6;
  border: none;
  padding-left: 1em;
  text-align: left;
  display: inline-block;
  margin: 4px 0;
  cursor: pointer;
  background: none;
  font-weight: normal;
`;

const PageSubtitle = styled.h3`
  font-size: 16px;
  line-height: 28px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.heading_dark};
  margin-bottom: 12px;
`;

export { PageTitle, PageSubtitle, PageLinks };
